export const MAX_CAMPAIGN_CSV_FILE_SIZE_MB = 10;

export enum PAGES {
	HOME = 'braze-campaigns',
	LIST = 'braze-campaigns.list',
	CREATE = 'braze-campaigns.create',
	DETAILS = 'braze-campaigns.details',
}
